import React, { createContext, useContext, useState } from 'react';
import PropTypes from 'prop-types';

import { HOME_STATUS } from './utils';

const EvieHomeContext = createContext();

const EvieHomeProvider = ({ children }) => {
  const [homeStatus, setHomeStatus] = useState(HOME_STATUS.IDLE);
  const [selectedTask, setSelectedTask] = useState(null);
  const [activityType, setActivityType] = useState(null);

  const handleChangeHomeStatus = (status) => {
    setHomeStatus(status);
  };

  return (
    <EvieHomeContext.Provider
      value={{
        homeStatus,
        changeHomeStatus: handleChangeHomeStatus,
        selectedTask,
        selectTask: setSelectedTask,
        activityType,
        setActivityType,
      }}
    >
      {children}
    </EvieHomeContext.Provider>
  );
};

EvieHomeProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

function useEvieHomeContext() {
  const context = useContext(EvieHomeContext);
  if (!context) {
    throw new Error('Expected an EvieHomeContext somewhere in the react tree to set context value');
  }
  return context;
}

export { useEvieHomeContext, EvieHomeProvider };
